export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/directionsIcon.c9023aed.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};